// FanData (Bloco 3 / T-14): número de protocolo formatado — sequencial puro derivado do
// display_id da conversa ("TKT-5152"). Uso interno (agente) e externo (passar pro torcedor).
export const TICKET_PREFIX = 'TKT';

export const formatTicket = displayId =>
  displayId ? `${TICKET_PREFIX}-${displayId}` : '';
